module.exports = __webpack_public_path__ + "img/43.8df62a0a.jpg";